import { useMutation, useQueryClient } from 'react-query';

import useApiHelper from '../../../hooks/useApiHelper';

import { useDefaultMutateResponseHandlers } from '../../../hooks/useDefaultMutateResponeHandlers';
import {
  IFaultDefinition,
  IFaultDefinitionCreateRequest,
  IFaultDefinitionDeleteRequest,
} from '../../../types/Fault/FaultDefinition';
import { faultQueryKeys } from '../../QueryKeys';

export default function useSuperAdminFaultDefinitionMutations() {
  const queryClient = useQueryClient();
  const { post, put, del } = useApiHelper();
  const { handleSuccess, handleError } =
    useDefaultMutateResponseHandlers('Fault Definition');

  const createFaultDefinition = useMutation({
    mutationFn: (faultDefinition: IFaultDefinitionCreateRequest) =>
      post('/v1/superadmin/fault/definitions', faultDefinition),
    onError: (error) => handleError(error, 'create'),
    onSuccess: (data) => handleSuccess(data, 'create'),
    onSettled: () =>
      queryClient.invalidateQueries(faultQueryKeys.superAdminDefinitions()),
  });

  const updateFaultDefinition = useMutation({
    mutationFn: (faultDefinition: IFaultDefinition) =>
      put<IFaultDefinition>(
        `/v1/superadmin/fault/definitions/${faultDefinition.id}`,
        faultDefinition
      ),
    onError: (error) => handleError(error, 'update'),
    onSuccess: (data) => handleSuccess(data, 'update'),
    onSettled: () =>
      queryClient.invalidateQueries(faultQueryKeys.superAdminDefinitions()),
  });

  const delFaultDefinition = useMutation({
    mutationFn: (faultDefinition: IFaultDefinitionDeleteRequest) =>
      del(`/v1/superadmin/fault/definitions/${faultDefinition.id}`),
    onError: (error) => handleError(error, 'delete'),
    onSuccess: (data) => handleSuccess(data, 'delete'),
    onSettled: () =>
      queryClient.invalidateQueries(faultQueryKeys.superAdminDefinitions()),
  });

  return {
    createFaultDefinition,
    updateFaultDefinition,
    delFaultDefinition,
  };
}
